import clsx from 'clsx';
import { useTranslate } from 'core/hooks/useTranslate';
import Button from '../../../../../atoms/Button/Button';
import TooltipCustom from 'core/modules/atoms/Tooltip';
import React from 'react';

/**
 * FloatingToggle - Floating menu component to toggle between edit and reorder modes
 */

type FloatingToggleProps = {
  reorderMode: boolean;
  onToggleMode: (mode: boolean) => void;
  hasOffset?: boolean;
  hasPendingChanges?: boolean;
};

function FloatingToggle({ reorderMode, onToggleMode, hasOffset = false, hasPendingChanges = false }: FloatingToggleProps): JSX.Element {
  const { t } = useTranslate();
  const handleEditClick = () => {
    if (!hasPendingChanges) {
      onToggleMode(false);
    }
  };

  const handleReorderClick = () => {
    onToggleMode(true);
  };

  return (
    <div className={clsx('floating-toggle', { 'floating-toggle--with-offset': hasOffset })}>
      <TooltipCustom title={t('organize-content:Edit program')} placement="top" hasArrow>
        <Button
          leftIcon="editpost"
          iconSize="md"
          isIconOnly
          onClick={handleEditClick}
          ariaLabel={t('organize-content:Edit program')}
          className={clsx('floating-toggle__button', {
            'floating-toggle__button--active': !reorderMode,
            'floating-toggle__button--disabled': hasPendingChanges,
          })}
          variant="secondary-ghost"
          aria-pressed={!reorderMode}
          isFullWidth
        />
      </TooltipCustom>
      <TooltipCustom title={t('organize-content:Reorder program')} placement="top" hasArrow>
        <Button
          leftIcon="drag-bullets"
          iconSize="md"
          isIconOnly
          onClick={handleReorderClick}
          ariaLabel={t('organize-content:Reorder program')}
          className={clsx('floating-toggle__button', { 'floating-toggle__button--active': reorderMode })}
          variant="secondary-ghost"
          aria-pressed={reorderMode}
          isFullWidth
        />
      </TooltipCustom>
    </div>
  );
}

export default FloatingToggle;
